import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { Tile } from '../property-information/property-information.component';
@Component({
  selector: 'app-scope-of-work',
  standalone: true,
  imports: [CommonModule, FormsModule, MatInputModule, MatSelectModule, MatButtonModule, MatFormFieldModule, MatCheckboxModule,
    MatTableModule, MatIconModule, MatGridListModule],
  templateUrl: './scope-of-work.component.html',
  styleUrl: './scope-of-work.component.scss'
})
export class ScopeOfWorkComponent {
  reportType!: string;
  approaches = {
    salesComparison: false,
    incomeCapDirect: false,
    incomeCapDiscounted: false,
    costApproach: false,
    insurableValue: false,
    actualCashValue: false,
    liquidationValue: false,
    dispositionValue: false,
    businessValue: false
  };

  scenarios = [
    { type: 'Row 1', premise: 123, interest: 456, timing: '' },
    { type: 'Row 2', premise: 123, interest: 456, timing: '' },
    { type: 'Row 3', premise: 123, interest: 456, timing: '' },
    { type: 'Row 4', premise: 123, interest: 456, timing: '' },
    { type: 'Row 5', premise: 123, interest: 456, timing: '' },
    { type: 'Row 6', premise: 123, interest: 456, timing: '' },
    { type: 'Row 7', premise: 123, interest: 456, timing: '' },
  ];

  displayedColumns: string[] = ['type', 'premise', 'interest', 'timing'];

  tiles: Tile[] = [
    {text: 'Approaches', cols: 1, rows: 6, color: 'lightblue'},
    {text: 'Scenarios', cols: 5, rows: 5, color: '#DDBDF1'},
  ];

  addScenario() {
    this.scenarios.push({ type: `Row ${this.scenarios.length + 1}`, premise: 0, interest: 0, timing: '' });
  }
}
